import React from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { extractResponseData, SmartHeader, NoRecordsCard, RawResponseButton } from './_SmartFieldRenderer';

const FuelPriceOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided state. Please verify and try again." />;
    }

    const d = responseData;
    const state = d.state || '';
    const petrolPrices = d.petrol_price || {};
    const dieselPrices = d.diesel_price || {};
    const districts = [...new Set([...Object.keys(petrolPrices), ...Object.keys(dieselPrices)])].sort();

    const tableData = districts.map((district) => ({
        district,
        petrol: petrolPrices[district] ?? null,
        diesel: dieselPrices[district] ?? null,
    }));

    const districtBody = (row) => <span className="capitalize">{row.district}</span>;
    const petrolBody = (row) => (
        <span className="font-mono text-green-600">{row.petrol != null ? `₹ ${row.petrol}` : '—'}</span>
    );
    const dieselBody = (row) => (
        <span className="font-mono text-orange-600">{row.diesel != null ? `₹ ${row.diesel}` : '—'}</span>
    );

    return (
        <div>
            <SmartHeader title="Fuel Price Report" icon="pi-dollar" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />

            <Card>
                {state && (
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-map-marker text-primary" aria-hidden="true" />
                        <Tag value={state.toUpperCase()} severity="info" />
                    </div>
                )}

                {tableData.length > 0 && (
                    <>
                        <div className="flex align-items-center gap-2 mb-2">
                            <i className="pi pi-chart-bar text-primary" aria-hidden="true" />
                            <span className="text-sm font-semibold text-900 uppercase">Fuel Prices by District</span>
                        </div>
                        <DataTable
                            value={tableData}
                            size="small"
                            stripedRows
                            showGridlines
                            responsiveLayout="scroll"
                            paginator={tableData.length > 10}
                            rows={10}
                            className="p-datatable-sm p-datatable-gridlines"
                        >
                            <Column field="district" header="District" body={districtBody} />
                            <Column field="petrol" header="Petrol" body={petrolBody} />
                            <Column field="diesel" header="Diesel" body={dieselBody} />
                        </DataTable>
                    </>
                )}

                <RawResponseButton data={d} />
            </Card>
        </div>
    );
};

export default FuelPriceOutputComponent;
